'use client';
import { QueryClientProvider } from '@tanstack/react-query';

import LoginBoundry from './components/LoginBoundry.js';
import { getQueryClient } from './lib/tanstack.js';
import DayTimeLimits from './messages/day-time-limit/DayTimeLimit.js';
import InactivityMessage from './messages/inactivity/InactivityMessage.js';
import RealityChecks from './messages/reality-checks/RealityChecks.js';
import SessionEndMessage from './messages/session-end/components/SessionEndMessage.js';
import SessionEnd from './messages/session-end/SessionEnd.js';
import type { ShowDialogFn } from './types.js';

type RealTimeMessagesProps = {
  showDialog: ShowDialogFn;
};

export default function RealTimeMessages({ showDialog }: RealTimeMessagesProps) {
  return (
    <QueryClientProvider client={getQueryClient()}>
      <LoginBoundry>
        <DayTimeLimits showDialog={showDialog} />
        <SessionEndMessage showDialog={showDialog} />
        <RealityChecks showDialog={showDialog} />
        <SessionEnd />
        <InactivityMessage showDialog={showDialog} />
      </LoginBoundry>
    </QueryClientProvider>
  );
}
